import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { usePendingApprovals } from "../hooks/usePendingApprovals";

let _audioCtx = null;

// Breve suono di notifica generato via Web Audio (nessun file audio richiesto).
const playChime = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    _audioCtx = _audioCtx || new Ctx();
    const ctx = _audioCtx;
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;
    [[880, 0], [1320, 0.13]].forEach(([freq, t]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + t);
      gain.gain.exponentialRampToValueAtTime(0.22, now + t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + t + 0.35);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + t);
      osc.stop(now + t + 0.4);
    });
  } catch { /* noop */ }
};

// Mostra un avviso (toast) — e un suono opzionale — quando ARRIVA una nuova richiesta
// da approvare (il conteggio, calcolato lato server per ruolo, aumenta). In tempo reale via WebSocket.
const ApprovalAlerts = () => {
  const { isApprover } = useAuth();
  const navigate = useNavigate();
  const { count } = usePendingApprovals(isApprover);
  const prev = useRef(null);

  useEffect(() => {
    if (!isApprover) { prev.current = null; return; }
    if (prev.current === null) { prev.current = count; return; } // salta il primo caricamento
    if (count > prev.current) {
      toast("Nuova richiesta da approvare", {
        description: `Hai ${count} ${count === 1 ? "richiesta" : "richieste"} in attesa`,
        action: { label: "Apri", onClick: () => navigate("/approvazioni") },
        duration: 8000,
      });
      if (localStorage.getItem("tb_approval_sound") !== "off") playChime();
    }
    prev.current = count;
  }, [count, isApprover, navigate]);

  return null;
};

export default ApprovalAlerts;
